/** STOMP destination builders — must match backend RealtimeTopics.java */
export const realtimeChannels = {
  userNotifications: '/user/queue/notifications',
  userApprovals: '/user/queue/approvals',

  orgDashboard: (orgId: number) => `/topic/org.${orgId}.dashboard`,

  storePos: (orgId: number, storeId: number) =>
    `/topic/org.${orgId}.store.${storeId}.pos`,

  storeInventory: (orgId: number, storeId: number) =>
    `/topic/org.${orgId}.store.${storeId}.inventory`,

  orgAttendance: (orgId: number) => `/topic/org.${orgId}.hr.attendance`,

  orgSocialInbox: (orgId: number) => `/topic/org.${orgId}.social.inbox`,

  orgLeadAssignments: (orgId: number) => `/topic/org.${orgId}.crm.lead-assignments`,

  posDisplay: (token: string) => `/topic/display.${token}`,
} as const;
